(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ht-dinner-meal-tiles"] && !Shopify.designMode) return;
  try {
    (() => {
  class HTDinnerMealTiles extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.media = matchMedia('(max-width: 767px)');
      this.desktop = this.dataset.desktop === 'true';
      this.addStyle = 'pill';
      this.root = document.querySelector('.order-tiffin-main-container');
      if (!this.root) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.root.addEventListener('click', event => {
        const recent = this.touchClick;
        if (recent && event.detail > 0 && Date.now() - recent.time < 800 &&
          (event.composedPath().includes(recent.button) || Math.hypot(event.clientX - recent.x, event.clientY - recent.y) < 16)) {
          this.touchClick = null;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const button = event.target.closest('.ht-meal-tile__select');
        if (!this.selectionInput(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.selectMeal(button);
      }, { signal: this.abort.signal, capture: true });
      this.root.addEventListener('touchstart', event => {
        this.touchClick = null;
        this.tap = null;
        const button = event.target.closest('.ht-meal-tile__select');
        if (event.touches.length !== 1 || !this.selectionInput(button)) return;
        const touch = event.touches[0];
        this.tap = { button, id: touch.identifier, x: touch.clientX, y: touch.clientY };
      }, { signal: this.abort.signal, capture: true, passive: true });
      this.root.addEventListener('touchmove', event => {
        const tap = this.tap;
        if (!tap) return;
        const touch = Array.from(event.touches).find(item => item.identifier === tap.id);
        if (event.touches.length !== 1 || !touch || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 12) this.tap = null;
      }, { signal: this.abort.signal, capture: true, passive: true });
      this.root.addEventListener('touchcancel', () => { this.tap = null; }, { signal: this.abort.signal, capture: true, passive: true });
      this.root.addEventListener('touchend', event => {
        const tap = this.tap;
        this.tap = null;
        if (!tap || event.touches.length || !this.selectionInput(tap.button)) return;
        const touch = Array.from(event.changedTouches).find(item => item.identifier === tap.id);
        if (!touch || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 12) return;
        const bounds = tap.button.getBoundingClientRect();
        if (touch.clientX < bounds.left || touch.clientX > bounds.right || touch.clientY < bounds.top || touch.clientY > bounds.bottom) return;
        event.preventDefault();
        this.touchClick = { button: tap.button, time: Date.now(), x: touch.clientX, y: touch.clientY };
        this.selectMeal(tap.button);
      }, { signal: this.abort.signal, capture: true, passive: false });
      this.media.addEventListener('change', this.schedule, { signal: this.abort.signal });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'disabled'] });
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.tap = null;
      this.touchClick = null;
      this.root?.querySelector('#mainProductContainer')?.classList.remove('ht-meal-tiles-enabled');
    }
    selectionInput(button) {
      if (!button?.isConnected || button.disabled || !(this.media.matches || this.desktop) ||
        !button.closest('#mainProductContainer.ht-meal-tiles-enabled') ||
        this.root.querySelector('.order-tiffin-type-btn.active')?.dataset.value !== 'tiffin') return null;
      const input = button.closest('.maintiffin-category-product-li')?.querySelector('.maintiffin-products-select');
      return input && !input.disabled ? input : null;
    }
    selectMeal(button) {
      const input = this.selectionInput(button);
      if (!input) return;
      input.click();
      this.sync();
    }
    setAttributeIfChanged(node, name, value) {
      if (node.getAttribute(name) !== value) node.setAttribute(name, value);
    }
    sync() {
      const main = this.root.querySelector('#mainProductContainer');
      if (!main) return;
      const enabled = (this.media.matches || this.desktop) && this.root.querySelector('.order-tiffin-type-btn.active')?.dataset.value === 'tiffin';
      main.classList.toggle('ht-meal-tiles-enabled', enabled);
      this.setAttributeIfChanged(main, 'data-add-style', this.addStyle);
      if (!enabled) return;
      main.querySelectorAll('.maintiffin-category-product-li').forEach(tile => {
        const input = tile.querySelector('.maintiffin-products-select');
        const label = tile.querySelector('.maintiffin-prod-radio-label');
        const wrapper = tile.querySelector('.maintiffin-input-label');
        if (!input || !label || !wrapper) return;
        if (!tile.classList.contains('ht-meal-tile')) {
          const details = document.createElement('button');
          details.type = 'button';
          details.className = 'ht-meal-tile__details icon-hover-main-desc';
          details.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="7.5" r="1.2" fill="currentColor"/></svg>';
          const detailsText = document.createElement('span');
          detailsText.textContent = this.dataset.detailsLabel;
          details.append(detailsText);
          details.setAttribute('aria-label', `${this.dataset.detailsLabel}: ${input.dataset.prodTitle}`);
          const select = document.createElement('button');
          select.type = 'button';
          select.className = 'ht-meal-tile__select';
          select.setAttribute('aria-label', `${this.dataset.selectLabel}: ${input.dataset.prodTitle}`);
          select.innerHTML = '<svg class="ht-meal-tile__check" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m4 10 4 4 8-8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><svg class="ht-meal-tile__plus" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span></span>';
          wrapper.append(details, select);
          tile.classList.add('ht-meal-tile');
        }
        const selected = label.classList.contains('active');
        const select = wrapper.querySelector('.ht-meal-tile__select');
        tile.classList.toggle('ht-meal-tile--selected', selected);
        this.setAttributeIfChanged(select, 'aria-pressed', String(selected));
        const text = selected ? this.dataset.selectedLabel : this.dataset.selectLabel;
        const span = select.querySelector('span');
        if (span.textContent !== text) span.textContent = text;
        if (select.disabled !== input.disabled) select.disabled = input.disabled;
      });
    }
  }
  if (!customElements.get('ht-dinner-meal-tiles')) customElements.define('ht-dinner-meal-tiles', HTDinnerMealTiles);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ht-gift-card-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ht-gift-card-form')) {
    customElements.define('ht-gift-card-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.toggle = this.querySelector('[data-gift-toggle]');
        this.fields = this.querySelector('[data-gift-fields]');
        this.email = this.querySelector('[data-gift-email]');
        this.submitButton = this.querySelector('[data-gift-submit]');
        this.error = this.querySelector('[data-gift-error]');
        this.toggle.disabled = false;
        this.toggle.addEventListener('change', () => this.syncRecipient());
        this.email.addEventListener('blur', () => { this.email.value = this.email.value.trim(); });
        this.submitButton.addEventListener('click', event => this.addToCart(event));
        this.form.addEventListener('submit', event => this.addToCart(event));
        this.form.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('[data-gift-email], [data-gift-name]')) this.addToCart(event);
        });
        window.addEventListener('pageshow', event => {
          if (event.persisted) {
            this.setBusy(false);
            this.syncRecipient();
          }
        });
        this.syncRecipient();
        this.setBusy(false);
      }
      syncRecipient() {
        const enabled = this.toggle.checked;
        this.fields.hidden = !enabled;
        this.fields.disabled = !enabled;
        this.email.required = enabled;
        this.toggle.setAttribute('aria-expanded', String(enabled));
        this.error.hidden = true;
      }
      setBusy(busy) {
        this.busy = busy;
        this.submitButton.disabled = busy || !this.querySelector('[data-gift-variant]:checked:not(:disabled)');
        this.form.setAttribute('aria-busy', String(busy));
        this.querySelector('[data-gift-idle]').hidden = busy;
        this.querySelector('[data-gift-busy]').hidden = !busy;
      }
      async addToCart(event) {
        event.preventDefault();
        if (this.busy) return;
        this.email.value = this.email.value.trim();
        if (this.toggle.checked && !this.email.checkValidity()) {
          this.error.textContent = this.dataset.emailError;
          this.error.hidden = false;
          this.email.focus();
          this.email.reportValidity();
          return;
        }
        const selected = this.querySelector('[data-gift-variant]:checked:not(:disabled)');
        if (!selected) return;
        this.error.hidden = true;
        const properties = { _gift_card: 'true' };
        if (this.toggle.checked) {
          properties.__shopify_send_gift_card_to_recipient = 'true';
          properties['Recipient email'] = this.email.value;
          const recipientName = this.querySelector('[data-gift-name]').value.trim();
          const message = this.querySelector('[data-gift-message]').value.trim();
          if (recipientName) properties['Recipient name'] = recipientName;
          if (message) properties.Message = message;
        }
        const payload = { id: selected.value, quantity: 1, properties };
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 30000);
        this.setBusy(true);
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            signal: controller.signal
          });
          const result = await response.json();
          if (!response.ok) {
            const detail = typeof result.description === 'string' ? result.description : '';
            throw new Error(detail || this.dataset.error);
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.error.textContent = error.name === 'AbortError' ? this.dataset.error : error.message || this.dataset.error;
          this.error.hidden = false;
          this.error.focus();
          this.setBusy(false);
        } finally {
          clearTimeout(timeout);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ht-home-slider-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ht-home-slider')) {
  class HtHomeSlider extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.track=this.querySelector('[data-track]');
      this.controls=this.querySelector('[data-controls]');
      if (!this.track || !this.controls) return;
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.motion.matches;
      this.hovered=false;
      this.focused=false;
      this.pauseButton=this.querySelector('[data-pause]');
      this.position=this.querySelector('[data-position]');
      this.positions=[];
      this.originalCards=Array.from(this.track.children);
      this.loopClones=[];
      if(this.position){
        this.position.addEventListener('input',()=>{
          this.paused=true;this.sync();
          this.track.scrollTo({left:this.positions[Number(this.position.value)]||0,behavior:'instant'});
        });
        this.track.addEventListener('scroll',()=>this.syncPosition(),{passive:true});
      }
      this.querySelector('[data-next]').addEventListener('click',()=>this.move(1));
      this.querySelector('[data-previous]').addEventListener('click',()=>this.move(-1));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.sync();});
      this.addEventListener('mouseenter',()=>{this.hovered=true;});
      this.addEventListener('mouseleave',()=>{this.hovered=false;});
      this.addEventListener('focusin',()=>{this.focused=true;});
      this.addEventListener('focusout',event=>{this.focused=this.contains(event.relatedTarget);});
      this.track.addEventListener('touchstart',()=>{this.paused=true;this.sync();},{passive:true});
      this.resize=new ResizeObserver(()=>this.measure());
      this.resize.observe(this.track);
      this.visibility=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;});
      this.visibility.observe(this);
      this.motionListener=()=>{if(this.motion.matches){this.paused=true;this.sync();}};
      this.motion.addEventListener('change',this.motionListener);
      this.timer=window.setInterval(()=>{if(!this.paused&&!this.hovered&&!this.focused&&this.inView&&!document.hidden)this.move(1);},Number(this.dataset.interval)||6000);
      this.sync();
    }
    measure(){
      if(this.dataset.loopShort==='true'&&this.originalCards.length>1){
        const first=this.originalCards[0].getBoundingClientRect();
        const last=this.originalCards[this.originalCards.length-1].getBoundingClientRect();
        const fits=last.right-first.left<=this.track.clientWidth+4;
        if(fits&&!this.loopClones.length){
          this.loopClones=this.originalCards.slice(0,-1).map(card=>{
            const clone=card.cloneNode(true);
            clone.dataset.loopClone='true';
            clone.setAttribute('aria-hidden','true');
            clone.setAttribute('tabindex','-1');
            clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el=>el.setAttribute('tabindex','-1'));
            this.track.append(clone);
            return clone;
          });
        }else if(!fits&&this.loopClones.length){
          this.loopClones.forEach(clone=>clone.remove());
          this.loopClones=[];
        }
      }
      const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
      this.controls.hidden=max<=4;
      if(this.position){
        this.position.hidden=max<=4;
        const first=this.track.firstElementChild;
        this.positions=first?[...new Set(Array.from(this.track.children).map(child=>Math.round(Math.min(max,child.getBoundingClientRect().left-first.getBoundingClientRect().left))))]:[0];
        if(this.positions[this.positions.length-1]<max)this.positions.push(max);
        this.position.max=String(Math.max(0,this.positions.length-1));
        this.syncPosition();
      }
    }
    syncPosition(){
      if(!this.position||!this.positions.length)return;
      let closest=0;
      this.positions.forEach((left,index)=>{if(Math.abs(left-this.track.scrollLeft)<Math.abs(this.positions[closest]-this.track.scrollLeft))closest=index;});
      this.position.value=String(closest);
    }
    sync(){this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel);this.track.setAttribute('aria-live',this.paused?'polite':'off');}
    move(direction){
      const children=Array.from(this.track.children);if(children.length<2)return;
      const current=this.track.scrollLeft,max=this.track.scrollWidth-this.track.clientWidth;
      const first=children[0].getBoundingClientRect().left;
      const next=children.find(child=>child.getBoundingClientRect().left>first+4);
      const step=next?next.getBoundingClientRect().left-first:this.track.clientWidth;
      let target=current+direction*step;
      if(direction>0&&current>=max-4)target=0;
      if(direction<0&&current<=4)target=max;
      this.track.scrollTo({left:Math.max(0,Math.min(max,target)),behavior:this.motion.matches?'instant':'smooth'});
    }
    disconnectedCallback(){window.clearInterval(this.timer);this.resize?.disconnect();this.visibility?.disconnect();this.motion?.removeEventListener('change',this.motionListener);this.loopClones?.forEach(clone=>clone.remove());this.ready=false;}
  }
  customElements.define('ht-home-slider',HtHomeSlider);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ht-menu-closed-message"] && !Shopify.designMode) return;
  try {
    function htMenuReleaseState(config, now) {
    const hour = value => {
      if (value === null || value === undefined || value === '') return null;
      if (/^\d{1,2}:\d{2}$/.test(String(value))) {
        const [hours, minutes] = String(value).split(':').map(Number);
        return hours < 24 && minutes < 60 ? hours + minutes / 60 : null;
      }
      const number = Number(value);
      return Number.isFinite(number) && number >= 0 && number < 24 ? number : null;
    };
    const release = hour(config?.release);
    const cutoff = hour(config?.cutoff);
    if (!config?.available || release === null || cutoff === null || cutoff > release) {
      return { reason: 'unavailable' };
    }
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', weekday: 'long', hour: '2-digit',
      minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date(now)).map(part => [part.type, part.value]));
    const time = Number(parts.hour) + Number(parts.minute) / 60;
    if (parts.weekday === 'Friday' && time >= cutoff && time < release) {
      const hours = Math.floor(release);
      const minutes = Math.round((release - hours) * 60);
      return {
        reason: 'scheduled',
        time: `${hours % 12 || 12}${minutes ? ':' + String(minutes).padStart(2, '0') : ''} ${hours >= 12 ? 'PM' : 'AM'}`
      };
    }
    const upcoming = parts.weekday === 'Saturday' || parts.weekday === 'Sunday' ||
      (parts.weekday === 'Friday' && time >= release);
    if (upcoming && [config.hide, config.disable].some(value => value === true || value === 'true')) {
      return { reason: 'held' };
    }
    return { reason: 'open' };
  }

  if (!customElements.get('ht-menu-closed-message')) {
    customElements.define('ht-menu-closed-message', class extends HTMLElement {
      connectedCallback() {
        if (this.timer) return;
        try {
          this.config = JSON.parse(this.querySelector('[data-ht-release-settings]').textContent);
        } catch {
          this.config = { available: false };
        }
        this.clockStart = performance.now();
        this.serverTime = Number(this.config.serverTime) * 1000 || Date.now();
        this.state = htMenuReleaseState(this.config, this.serverTime);
        this.paint(this.state);
        this.refresh = () => {
          const url = new URL(window.location.href);
          if (this.dataset.previewTheme) url.searchParams.set('preview_theme_id', this.dataset.previewTheme);
          window.location.assign(url.href);
        };
        this.querySelector('[data-menu-release-refresh]').addEventListener('click', this.refresh);
        this.onVisible = () => { if (!document.hidden) this.check(); };
        document.addEventListener('visibilitychange', this.onVisible);
        this.timer = setInterval(() => this.check(), 30000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.timer = null;
        this.querySelector('[data-menu-release-refresh]')?.removeEventListener('click', this.refresh);
        document.removeEventListener('visibilitychange', this.onVisible);
      }

      paint(state) {
        const message = state.reason === 'scheduled'
          ? this.dataset.scheduled.replace('[time]', state.time)
          : state.reason === 'unavailable' ? this.dataset.unavailable : this.dataset.held;
        this.querySelector('[data-menu-release-title]').textContent = message;
      }

      async check() {
        if (this.busy || document.hidden || !this.getClientRects().length) return;
        this.busy = true;
        try {
          const url = new URL(window.location.href);
          if (this.dataset.previewTheme) url.searchParams.set('preview_theme_id', this.dataset.previewTheme);
          url.searchParams.set('section_id', 'ht-menu-release-status');
          url.searchParams.set('_ht_release', String(Date.now()));
          const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = html.querySelector('[data-ht-release-settings]');
          if (!data) return;
          const config = JSON.parse(data.textContent);
          const now = Number(config.serverTime) * 1000 || this.serverTime + performance.now() - this.clockStart;
          const next = htMenuReleaseState(config, now);
          if (next.reason === 'open' && this.state.reason !== 'open') {
            this.refresh();
            return;
          }
          this.config = config;
          this.state = next;
          this.paint(next);
        } catch {
          return;
        } finally {
          this.busy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ht-mobile-menu-links"] && !Shopify.designMode) return;
  try {
    (() => {
  class HTMobileMenuLinks extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.media = matchMedia('(max-width: 749px)');
      const options = { signal: this.abort.signal, capture: true, passive: true };
      document.addEventListener('touchstart', event => {
        this.clearTap();
        this.touchClick = null;
        const link = this.linkFor(event.target);
        if (event.defaultPrevented || event.touches.length !== 1 || !this.eligible(link)) return;
        const touch = event.touches[0];
        this.tap = { link, id: touch.identifier, x: touch.clientX, y: touch.clientY, time: Date.now() };
        link.classList.add('ht-menu-link-pressed');
      }, options);
      document.addEventListener('touchmove', event => {
        const tap = this.tap;
        if (!tap) return;
        const touch = Array.from(event.touches).find(item => item.identifier === tap.id);
        if (event.touches.length !== 1 || !touch || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 12) this.clearTap();
      }, options);
      document.addEventListener('touchcancel', () => this.clearTap(), options);
      document.addEventListener('scroll', () => this.clearTap(), options);
      this.media.addEventListener('change', () => this.clearTap(), { signal: this.abort.signal });
      document.addEventListener('touchend', event => {
        const tap = this.tap;
        this.clearTap();
        if (!tap || event.defaultPrevented || event.touches.length || Date.now() - tap.time > 500 || !this.eligible(tap.link)) return;
        const touch = Array.from(event.changedTouches).find(item => item.identifier === tap.id);
        if (!touch || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 12) return;
        const bounds = tap.link.getBoundingClientRect();
        if (touch.clientX < bounds.left || touch.clientX > bounds.right || touch.clientY < bounds.top || touch.clientY > bounds.bottom) return;
        event.preventDefault();
        this.touchClick = { link: tap.link, time: Date.now() };
        tap.link.click();
      }, { signal: this.abort.signal, capture: true, passive: false });
      window.addEventListener('click', event => {
        const recent = this.touchClick;
        if (!recent || event.detail === 0 || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || Date.now() - recent.time >= 800 || this.linkFor(event.target) !== recent.link) return;
        this.touchClick = null;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { signal: this.abort.signal, capture: true });
    }
    disconnectedCallback() {
      this.clearTap();
      this.touchClick = null;
      this.abort?.abort();
      this.abort = null;
    }
    linkFor(target) {
      return target instanceof Element ? target.closest('.mct-tabs a.mct-tab[href]') : null;
    }
    eligible(link) {
      if (!this.media.matches || !link?.isConnected || link.matches('[aria-disabled="true"], [download]') || (link.target && link.target.toLowerCase() !== '_self')) return false;
      try {
        const url = new URL(link.href, location.href);
        return /^https?:$/.test(url.protocol) && url.origin === location.origin;
      } catch {
        return false;
      }
    }
    clearTap() {
      this.tap?.link.classList.remove('ht-menu-link-pressed');
      this.tap = null;
    }
  }
  if (!customElements.get('ht-mobile-menu-links')) customElements.define('ht-mobile-menu-links', HTMobileMenuLinks);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ht-mobile-order-dock"] && !Shopify.designMode) return;
  try {
    (() => {
  class HTMobileOrderDock extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.labels = this.dataset.days.split(',');
      this.days = ['monday','tuesday','wednesday','thursday','friday'];
      this.media = matchMedia('(max-width: 767px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.addEventListener('click', event => this.activate(event), {signal: this.abort.signal});
      document.addEventListener('ht:order-dock-state', this.schedule, {signal: this.abort.signal});
      document.addEventListener('click', this.schedule, {signal: this.abort.signal});
      document.addEventListener('change', this.schedule, {signal: this.abort.signal});
      this.media.addEventListener('change', this.schedule, {signal: this.abort.signal});
      this.observer = new MutationObserver(this.schedule);
      const main = document.querySelector('.order-tiffin-main-container');
      if (main) this.observer.observe(main, {subtree:true,childList:true,attributes:true,attributeFilter:['class','style','disabled']});
      this.bodyObserver = new MutationObserver(() => this.syncSheet());
      this.bodyObserver.observe(document.body, {attributes:true,attributeFilter:['class']});
      document.addEventListener('keydown', event => this.sheetKeydown(event), {signal:this.abort.signal});
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.bodyObserver?.disconnect(); cancelAnimationFrame(this.frame);
      this.initialized = false; this.frame = 0;
      document.body.classList.remove('ht-order-dock-ready');
      document.body.style.removeProperty('--ht-order-dock-space');
      this.releaseSheet();
      const wrapper = document.querySelector('.cart-summary-wrapper');
      wrapper?.querySelectorAll('.ht-sheet-header, .ht-sheet-edit').forEach(node => node.remove());
      wrapper?.querySelectorAll('.ht-tiffin-editing').forEach(node => node.classList.remove('ht-tiffin-editing'));
    }
    put(selector, value) {
      const node = this.querySelector(selector);
      if (node && node.textContent !== value) node.textContent = value;
    }
    sync() {
      const state = window.htOrderDockState;
      const calendar = Array.from(document.querySelectorAll('#weekContainer .tiffin-calendar-day-btn')).filter(button => this.days.includes(button.dataset.day) && !button.disabled && !button.hidden);
      const current = calendar.findIndex(button => button.classList.contains('active-day'));
      const main = document.querySelector('.order-tiffin-main-container');
      const ready = Boolean(this.media.matches && state && main && getComputedStyle(main).display !== 'none' && current >= 0);
      this.hidden = !ready;
      document.body.classList.toggle('ht-order-dock-ready', ready);
      if (!ready) { this.syncSheet(); return; }
      this.previous = calendar[current-1] || null;
      this.next = calendar[current+1] || null;
      this.finalDay = calendar[current].dataset.day === 'friday' || !this.next;
      this.dataset.finalDay = String(this.finalDay);
      const prev = this.querySelector('[data-dock-action="previous"]');
      prev.disabled = !this.previous;
      const previousLabel = this.previous ? this.labels[this.days.indexOf(this.previous.dataset.day)] : '';
      const nextLabel = this.next ? this.labels[this.days.indexOf(this.next.dataset.day)] : '';
      this.put('[data-previous-day]', previousLabel);
      prev.setAttribute('aria-label', `${this.dataset.previousLabel}${previousLabel ? ': '+previousLabel : ''}`);
      const forward = this.querySelector('[data-dock-action="forward"]');
      const checkout = document.querySelector('.cart-summary-checkout-btn .tiffin-add-to-cart');
      const loader = document.querySelector('.loading-tiffin-checkout');
      const busy = Boolean(checkout?.disabled || (loader && !loader.classList.contains('hidden')));
      forward.disabled = this.finalDay ? busy : !this.next;
      this.put('[data-forward-label]', this.finalDay ? this.dataset.checkoutLabel : nextLabel);
      forward.setAttribute('aria-label', this.finalDay ? this.dataset.checkoutLabel : `${this.dataset.nextLabel}: ${nextLabel}`);
      const total = this.money.format(state.total || 0);
      this.put('[data-cart-total]', total);
      this.put('[data-checkout-total]', total);
      this.querySelector('[data-checkout-total]').hidden = !this.finalDay || total.length > 9;
      const count = Math.max(0, Number(state.count) || 0);
      this.put('[data-cart-count]', count > 99 ? '99+' : String(count));
      this.querySelector('[data-cart-count]').hidden = count === 0;
      this.querySelector('[data-dock-action="cart"]').setAttribute('aria-label', `${this.dataset.cartLabel}: ${count}, ${total}`);
      this.put('[data-cart-status]', `${this.dataset.cartLabel}: ${count}, ${total}`);
      const nativeAdd = document.querySelector('.tiffin-add-anothertiffin-btn');
      const activeType = document.querySelector('.order-tiffin-type-btn.active')?.dataset.value;
      const showAdd = this.dataset.dinner === 'true' && activeType === 'tiffin';
      this.canAdd = showAdd && Boolean(nativeAdd && nativeAdd.style.display !== 'none' && !nativeAdd.disabled);
      this.querySelector('.ht-order-dock__add-wrap').hidden = !showAdd;
      this.querySelector('[data-dock-action="add"]').disabled = !this.canAdd;
      document.body.style.setProperty('--ht-order-dock-space', showAdd ? '112px' : '68px');
      this.syncSheet();
    }
    syncSheet() {
      const body = document.body;
      const showingCart = this.media.matches && body.classList.contains('ht-order-dock-ready') && body.classList.contains('mobile-cart-summary') && !body.classList.contains('popup-description');
      if (showingCart) {
        const opening = !body.classList.contains('ht-cart-sheet');
        if (opening) body.classList.add('ht-cart-sheet');
        this.enhanceSheet();
        if (opening) document.querySelector('.ht-sheet-done')?.focus({preventScroll:true});
      } else if (body.classList.contains('ht-cart-sheet')) {
        this.releaseSheet();
      }
    }
    openCart() {
      const container = document.querySelector('.cart-summary-container');
      if (!container) return;
      document.body.classList.add('mobile-cart-summary', 'popup-validation', 'ht-cart-sheet');
      document.body.classList.remove('popup-description');
      container.classList.add('cart-summary-swipe');
      document.querySelectorAll('.cart-summary-popover-info').forEach(popover => { popover.style.display = 'block'; });
      const description = document.querySelector('.desktop-product-popup-holder');
      if (description) description.style.display = 'none';
      this.enhanceSheet();
      document.querySelector('.ht-sheet-done')?.focus({preventScroll:true});
    }
    enhanceSheet() {
      const wrapper = document.querySelector('.cart-summary-wrapper');
      const popover = wrapper?.querySelector('.cart-summary-popover-info');
      if (!popover) return;
      if (!popover.querySelector('.ht-sheet-header')) {
        const header = document.createElement('div');
        header.className = 'ht-sheet-header';
        const title = document.createElement('h2'); title.id = 'ht-sheet-title'; title.textContent = this.dataset.sheetTitle;
        const done = document.createElement('button'); done.type = 'button'; done.className = 'ht-sheet-done'; done.textContent = this.dataset.doneLabel;
        done.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.closeSheet(); }, {signal:this.abort.signal});
        header.append(title,done); popover.prepend(header);
      }
      wrapper.setAttribute('role','dialog'); wrapper.setAttribute('aria-modal','true'); wrapper.setAttribute('aria-labelledby','ht-sheet-title');
      popover.querySelectorAll('.remove-btn').forEach(button => {
        if (!button.getAttribute('aria-label')) {
          const row = button.closest('.added-category-wrapper');
          const title = row?.querySelector('.added-title, .added-cat-imgtitle-wrap span')?.textContent.trim();
          button.setAttribute('aria-label', `${this.dataset.removeLabel}: ${title || ''}`);
        }
      });
      popover.querySelectorAll('.main-tiffin-section .section-header-cartsummary').forEach(header => {
        if (header.querySelector('.ht-sheet-edit')) return;
        const edit = document.createElement('button'); edit.type = 'button'; edit.className = 'ht-sheet-edit'; edit.textContent = this.dataset.editLabel; edit.setAttribute('aria-expanded','false');
        edit.addEventListener('click', event => {
          event.preventDefault(); event.stopPropagation();
          const expanded = header.closest('.main-tiffin-section').classList.toggle('ht-tiffin-editing');
          edit.setAttribute('aria-expanded',String(expanded)); edit.textContent = expanded ? this.dataset.doneLabel : this.dataset.editLabel;
        }, {signal:this.abort.signal});
        header.append(edit);
      });
      const total = popover.querySelector('.total-price-info > span');
      if (total && window.htOrderDockState) {
        const formattedTotal = this.money.format(Number(window.htOrderDockState.total)||0);
        if (total.textContent !== formattedTotal) total.textContent = formattedTotal;
      }
    }
    async closeSheet() {
      if (this.closing) return;
      this.closing = true;
      const wrapper = document.querySelector('.cart-summary-wrapper');
      if (wrapper?.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        try { await wrapper.animate([{transform:'translateY(0)'},{transform:'translateY(100%)'}], {duration:220,easing:'cubic-bezier(.4,0,1,1)'}).finished; } catch {}
      }
      document.body.classList.remove('mobile-cart-summary');
      document.querySelector('.cart-summary-container')?.classList.remove('cart-summary-swipe');
      this.releaseSheet(); this.closing = false;
    }
    releaseSheet() {
      document.body.classList.remove('ht-cart-sheet');
      const wrapper = document.querySelector('.cart-summary-wrapper');
      wrapper?.removeAttribute('role'); wrapper?.removeAttribute('aria-modal'); wrapper?.removeAttribute('aria-labelledby');
      if (!document.body.classList.contains('mobile-cart-summary')) this.querySelector('[data-dock-action="cart"]')?.focus({preventScroll:true});
    }
    sheetKeydown(event) {
      if (!document.body.classList.contains('ht-cart-sheet') || document.body.classList.contains('popup-description')) return;
      const wrapper = document.querySelector('.cart-summary-wrapper');
      if (!wrapper?.contains(event.target)) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.closeSheet(); }
      if (event.key !== 'Tab') return;
      const buttons = Array.from(wrapper.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),textarea:not(:disabled),[tabindex="0"]')).filter(node=>node.getClientRects().length);
      if (!buttons.length) return;
      if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons.at(-1).focus(); }
      if (!event.shiftKey && document.activeElement === buttons.at(-1)) { event.preventDefault(); buttons[0].focus(); }
    }
    activate(event) {
      event.stopPropagation();
      const button = event.target.closest('[data-dock-action]');
      if (!button) return;
      event.preventDefault();
      this.sync();
      if (button.disabled) return;
      const action = button.dataset.dockAction;
      if (action === 'cart') this.openCart();
      if (action === 'add' && this.canAdd) document.querySelector('.tiffin-add-anothertiffin-btn')?.click();
      if (action === 'previous' && this.previous) { this.previous.click(); document.querySelector('.tiffin-day-week-swiper-container')?.scrollIntoView({block:'start'}); }
      if (action === 'forward' && !this.finalDay && this.next) { this.next.click(); document.querySelector('.tiffin-day-week-swiper-container')?.scrollIntoView({block:'start'}); }
      if (action === 'forward' && this.finalDay) {
        if (!window.htOrderDockState?.count) this.openCart();
        else document.querySelector('.cart-summary-checkout-btn .tiffin-add-to-cart')?.click();
      }
      this.schedule();
    }
  }
  if (!customElements.get('ht-mobile-order-dock')) customElements.define('ht-mobile-order-dock', HTMobileOrderDock);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ht-quantity-meal-tiles"] && !Shopify.designMode) return;
  try {
    (() => {
  class HTQuantityMealTiles extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.media = matchMedia('(max-width: 767px)');
      this.desktop = this.dataset.desktop === 'true';
      this.root = document.querySelector('.order-tiffin-main-container');
      if (!this.root) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.root.addEventListener('click', event => {
        const recent = this.touchClick;
        if (recent && event.detail > 0 && Date.now() - recent.time < 800 &&
          (event.composedPath().includes(recent.button) || Math.hypot(event.clientX - recent.x, event.clientY - recent.y) < 16)) {
          this.touchClick = null;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const button = event.target.closest('[data-quantity-action]');
        if (!this.eligible(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.activate(button);
      }, { signal: this.abort.signal, capture: true });
      this.root.addEventListener('touchstart', event => {
        this.touchClick = null;
        this.tap = null;
        const button = event.target.closest('[data-quantity-action]');
        if (event.touches.length !== 1 || !this.eligible(button)) return;
        const touch = event.touches[0];
        this.tap = { button, id: touch.identifier, x: touch.clientX, y: touch.clientY };
      }, { signal: this.abort.signal, capture: true, passive: true });
      this.root.addEventListener('touchmove', event => {
        const tap = this.tap;
        if (!tap) return;
        const touch = Array.from(event.touches).find(item => item.identifier === tap.id);
        if (event.touches.length !== 1 || !touch || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 12) this.tap = null;
      }, { signal: this.abort.signal, capture: true, passive: true });
      this.root.addEventListener('touchcancel', () => { this.tap = null; }, { signal: this.abort.signal, capture: true, passive: true });
      this.root.addEventListener('touchend', event => {
        const tap = this.tap;
        this.tap = null;
        if (!tap || event.touches.length || !this.eligible(tap.button)) return;
        const touch = Array.from(event.changedTouches).find(item => item.identifier === tap.id);
        if (!touch || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 12) return;
        const bounds = tap.button.getBoundingClientRect();
        if (touch.clientX < bounds.left || touch.clientX > bounds.right || touch.clientY < bounds.top || touch.clientY > bounds.bottom) return;
        event.preventDefault();
        this.touchClick = { button: tap.button, time: Date.now(), x: touch.clientX, y: touch.clientY };
        this.activate(tap.button);
      }, { signal: this.abort.signal, capture: true, passive: false });
      document.addEventListener('click', this.schedule, { signal: this.abort.signal });
      document.addEventListener('ht:order-dock-state', this.schedule, { signal: this.abort.signal });
      this.media.addEventListener('change', this.schedule, { signal: this.abort.signal });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'disabled', 'data-prod-variant', 'data-available', 'data-max-qty', 'data-out-of-stock'] });
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.restorePantryPrices();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.tap = null;
      this.touchClick = null;
      this.root?.classList.remove('ht-quantity-tiles-enabled');
    }
    savedState() {
      try {
        const state = JSON.parse(localStorage.getItem(window.HT_MORNING_PREVIEW ? 'htMorningPreviewSelections' : 'selectedTiffins') || 'null');
        return state?.days && typeof state.days === 'object' ? state : null;
      } catch {
        return null;
      }
    }
    nativeState(tile, saved = this.savedState()) {
      const lunch = tile.classList.contains('lunchcategory-product-li');
      const pantry = tile.classList.contains('pantrycategory-product-li');
      const type = pantry ? 'pantry' : lunch ? 'lunch' : 'ala';
      const wrapper = tile.querySelector(pantry ? '.pantry-addto-cart' : lunch ? '.lunch-addto-cart' : '.ala-cart-quanity-wrapper');
      if (!wrapper) return null;
      const add = wrapper.querySelector(pantry ? '.pantry-plus-icon-main' : lunch ? '.lunch-plus-icon-main' : '.ala-addto-cart');
      const selector = wrapper.querySelector(pantry ? '.pantry-quantity-selector' : lunch ? '.lunch-quantity-selector' : '.quanityselectortoggle');
      const input = wrapper.querySelector(pantry ? '.pantry-prod-input' : lunch ? '.lunch-prod-input' : '.tiffinday-input-ala');
      if (!add || !selector || !input) return null;
      const nativeExpanded = lunch || pantry ? !selector.classList.contains('hidden') : selector.style.display === 'flex';
      const collapsedCount = /^\d+$/.test(add.textContent.trim()) ? Number(add.textContent.trim()) : 0;
      const item = saved?.days?.[wrapper.dataset.dayName]?.[type]?.[wrapper.dataset.categoryName]?.[wrapper.dataset.prodVariant];
      const quantity = Math.max(0, Number(saved ? (item?.quantity || 0) : (nativeExpanded ? input.value : collapsedCount)) || 0);
      const expanded = nativeExpanded && quantity > 0;
      return { add, input, expanded, quantity,
        increase: wrapper.querySelector(pantry ? '.pantry-plus-icon' : lunch ? '.lunch-quantity-plus-icon' : '.plus-quantity-selector-ala'),
        decrease: wrapper.querySelector(pantry ? (quantity > 1 ? '.pantry-minus-icon' : '.pantry-delete-icon') : lunch ? (quantity > 1 ? '.lunch-quantity-minus-icon' : '.lunch-delete-icon') : (quantity > 1 ? '.minus-quanity-minus-ala' : '.minus-quantity-remove')),
        details: tile.querySelector(pantry ? '.icon-hover-pantry-desc' : lunch ? '.icon-hover-lunch-desc' : '.icon-hover-alacarte'),
        title: (tile.querySelector(pantry ? '.pantry-prod-title' : lunch ? '.lunch-prod-title' : '.alacarte-prod-title')?.textContent || '').trim()
      };
    }
    inlinePantryPrice(tile) {
      if (!tile.classList.contains('pantrycategory-product-li')) return;
      const price = tile.querySelector('.pantry-prod-finalprice');
      const description = tile.querySelector('.pantry-desc-content');
      if (!price || !description || price.parentElement === description) return;
      this.priceHomes ||= new Map();
      for (const [node] of this.priceHomes) if (!node.isConnected) this.priceHomes.delete(node);
      this.priceHomes.set(price, { parent: price.parentElement, next: price.nextSibling });
      description.append(price);
    }
    restorePantryPrices() {
      for (const [price, home] of this.priceHomes || []) {
        if (price.isConnected && home.parent.isConnected) home.parent.insertBefore(price, home.next?.parentNode === home.parent ? home.next : null);
      }
      this.priceHomes?.clear();
    }
    eligible(button) {
      return Boolean(button?.isConnected && !button.disabled && !button.closest('[hidden]') && (this.media.matches || this.desktop) &&
        button.closest('.ht-quantity-tiles-enabled .ht-quantity-tile'));
    }
    activate(button) {
      if (!this.eligible(button)) return;
      const state = this.nativeState(button.closest('.ht-quantity-tile'));
      const native = state?.[button.dataset.quantityAction];
      if (!native || native.matches(':disabled, [disabled], [aria-disabled="true"]') || (button.dataset.quantityAction !== 'details' && state.input.disabled)) return;
      if (button.dataset.quantityAction === 'add') state.input.value = String(state.quantity || 1);
      native.click();
      this.sync();
    }
    attr(node, name, value) {
      if (node.getAttribute(name) !== value) node.setAttribute(name, value);
    }
    hidden(node, value) {
      if (node.hidden !== value) node.hidden = value;
    }
    text(node, value) {
      if (node.textContent !== value) node.textContent = value;
    }
    enhance(tile, saved) {
      const content = tile.querySelector('.alacarte-prod-content, .lunch-prod-content, .pantry-prod-content');
      const wrapper = tile.querySelector('.alacarte-category-prod-wrapper, .lunch-prod-wrapper, .pantry-prod-wrapper');
      if (!content || !wrapper || !this.nativeState(tile, saved)) return;
      const actions = document.createElement('div');
      actions.className = 'ht-quantity-tile__actions';
      actions.innerHTML = '<button type="button" class="ht-quantity-tile__add" data-quantity-action="add"><svg class="ht-quantity-tile__plus" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><svg class="ht-quantity-tile__check" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m4 10 4 4 8-8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span data-quantity-add-label></span></button><div class="ht-quantity-tile__stepper" hidden><button type="button" data-quantity-action="decrease"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><output data-quantity-value aria-live="polite"></output><button type="button" data-quantity-action="increase"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div>';
      const details = document.createElement('button');
      details.type = 'button';
      details.className = 'ht-quantity-tile__details';
      details.dataset.quantityAction = 'details';
      details.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="7.5" r="1.2" fill="currentColor"/></svg>';
      const label = document.createElement('span');
      label.textContent = this.dataset.detailsLabel;
      details.append(label);
      content.append(actions);
      wrapper.append(details);
      tile.classList.add('ht-quantity-tile');
    }
    sync() {
      const enabled = this.media.matches || this.desktop;
      if (this.root.classList.contains('ht-quantity-tiles-enabled') !== enabled) this.root.classList.toggle('ht-quantity-tiles-enabled', enabled);
      if (!enabled) { this.restorePantryPrices(); return; }
      const saved = this.savedState();
      this.root.querySelectorAll('#alaProductContainer .alacarte-category-product-li, #lunchProductContainer .lunchcategory-product-li, #pantryProductContainer .pantrycategory-product-li').forEach(tile => {
        if (!tile.classList.contains('ht-quantity-tile')) this.enhance(tile, saved);
        this.inlinePantryPrice(tile);
        const state = this.nativeState(tile, saved);
        const actions = tile.querySelector('.ht-quantity-tile__actions');
        if (!state || !actions) return;
        const selected = state.quantity > 0;
        if (tile.classList.contains('ht-quantity-tile--selected') !== selected) tile.classList.toggle('ht-quantity-tile--selected', selected);
        const add = actions.querySelector('[data-quantity-action="add"]');
        this.hidden(add, state.expanded);
        this.hidden(actions.querySelector('.ht-quantity-tile__stepper'), !state.expanded);
        this.text(actions.querySelector('[data-quantity-add-label]'), selected ? (state.quantity > 99 ? '99+' : String(state.quantity)) : this.dataset.addLabel);
        this.text(actions.querySelector('[data-quantity-value]'), String(state.quantity));
        this.attr(add, 'aria-label', selected ? `${this.dataset.quantityLabel}: ${state.title}, ${state.quantity}` : `${this.dataset.addLabel}: ${state.title}`);
        this.attr(add, 'aria-expanded', String(state.expanded));
        this.attr(actions.querySelector('[data-quantity-value]'), 'aria-label', `${this.dataset.quantityLabel}: ${state.title}`);
        this.attr(actions.querySelector('[data-quantity-action="increase"]'), 'aria-label', `${this.dataset.increaseLabel}: ${state.title}`);
        this.attr(actions.querySelector('[data-quantity-action="decrease"]'), 'aria-label', `${state.quantity > 1 ? this.dataset.decreaseLabel : this.dataset.removeLabel}: ${state.title}`);
        for (const button of actions.querySelectorAll('button')) {
          const native = state[button.dataset.quantityAction];
          const disabled = Boolean(state.input.disabled || !native || native.matches(':disabled, [disabled], [aria-disabled="true"]'));
          if (button.disabled !== disabled) button.disabled = disabled;
        }
        const details = tile.querySelector('.ht-quantity-tile__details');
        this.hidden(details, !state.details);
        this.attr(details, 'aria-label', `${this.dataset.detailsLabel}: ${state.title}`);
      });
    }
  }
  if (!customElements.get('ht-quantity-meal-tiles')) customElements.define('ht-quantity-meal-tiles', HTQuantityMealTiles);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ht-tiffin-completion-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  class HTTiffinCompletionGuard extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.abort = new AbortController();
      this.categories = ['proteins', 'veggies', 'sides', 'probiotics'];
      this.copyNodes = ['#ht-tiffin-guard-title', '#ht-tiffin-guard-intro', '.ht-tiffin-guard__hint'].map(selector => this.querySelector(selector));
      this.defaultCopy = this.copyNodes.map(node => node?.textContent || '');
      document.addEventListener('click', event => this.guard(event), { capture: true, signal: this.abort.signal });
      this.querySelector('.ht-tiffin-guard__close').addEventListener('click', () => this.dialog.close(), { signal: this.abort.signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dialog.close(); }, { signal: this.abort.signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal: this.abort.signal });
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('ht-tiffin-guard-open');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('ht-tiffin-guard-open');
      this.abort?.abort();
      this.abort = null;
    }
    calendar() {
      return Array.from(document.querySelectorAll('#weekContainer .tiffin-calendar-day-btn')).filter(button => !button.disabled && !button.hidden);
    }
    outgoing(target) {
      const control = target.closest('[data-dock-action], .tiffin-calendar-day-btn, .tiffin-prev-tiffin-day, .next-tiffin-day, .tiffin-goto-nextday-btn, .order-tiffin-type-btn, .tiffin-add-to-cart, .t4s-btn__checkout_button, a[href]');
      if (!control || control.matches(':disabled, .disabled, [aria-disabled="true"]')) return null;
      const calendar = this.calendar();
      const index = calendar.findIndex(button => button.classList.contains('active-day'));
      const current = calendar[index];
      if (!current) return null;
      if (control.matches('.tiffin-calendar-day-btn')) return control !== current ? control : null;
      if (control.matches('.order-tiffin-type-btn')) return control.dataset.value !== 'tiffin' ? control : null;
      if (control.matches('.tiffin-prev-tiffin-day') || control.dataset.dockAction === 'previous') return calendar[index - 1] ? control : null;
      if (control.matches('.next-tiffin-day, .tiffin-goto-nextday-btn')) return calendar[index + 1] ? control : null;
      if (control.dataset.dockAction === 'forward' || control.matches('.tiffin-add-to-cart, .t4s-btn__checkout_button')) return control;
      if (!control.matches('a[href]') || control.hasAttribute('download') || (control.target && control.target.toLowerCase() !== '_self')) return null;
      try {
        const url = new URL(control.href, location.href);
        const pathname = path => path.replace(/\/+$/, '') || '/';
        return url.origin === location.origin && /^https?:$/.test(url.protocol) && pathname(url.pathname) !== pathname(location.pathname) ? control : null;
      } catch {
        return null;
      }
    }
    missingTiffins(day) {
      try {
        const state = JSON.parse(localStorage.getItem(window.HT_MORNING_PREVIEW ? 'htMorningPreviewSelections' : 'selectedTiffins') || 'null');
        const tiffins = state?.days?.[day]?.tiffins;
        if (!tiffins || typeof tiffins !== 'object' || Array.isArray(tiffins)) return [];
        return Object.entries(tiffins).sort(([a], [b]) => Number(a) - Number(b)).flatMap(([number, tiffin]) => {
          if (!tiffin || typeof tiffin !== 'object' || Array.isArray(tiffin) || !this.categories.some(category => Boolean(tiffin[category]))) return [];
          const missing = this.categories.filter(category => !tiffin[category]);
          return missing.length ? [{ number, missing }] : [];
        });
      } catch {
        return [];
      }
    }
    lunchBelowMinimum(day) {
      try {
        const state = JSON.parse(localStorage.getItem(window.HT_MORNING_PREVIEW ? 'htMorningPreviewSelections' : 'selectedTiffins') || 'null');
        const lunch = state?.days?.[day]?.lunch;
        if (!lunch || typeof lunch !== 'object' || Array.isArray(lunch)) return false;
        let cents = 0;
        let hasLunch = false;
        for (const category of Object.values(lunch)) {
          if (!category || typeof category !== 'object' || Array.isArray(category)) continue;
          for (const item of Object.values(category)) {
            if (!item || typeof item !== 'object') continue;
            const quantity = Number(item.quantity) || 0;
            if (!Number.isFinite(quantity) || quantity <= 0) continue;
            const price = Number.parseFloat(item.price || 0);
            if (!Number.isFinite(price) || price < 0) return false;
            hasLunch = true;
            cents += Math.round(price * 100) * quantity;
          }
        }
        return hasLunch && Math.round(cents) < 2000;
      } catch {
        return false;
      }
    }
    alaBelowMinimum(day) {
      try {
        const state = JSON.parse(localStorage.getItem(window.HT_MORNING_PREVIEW ? 'htMorningPreviewSelections' : 'selectedTiffins') || 'null');
        const dayOrder = state?.days?.[day];
        const tiffins = dayOrder?.tiffins;
        if (tiffins && typeof tiffins === 'object' && !Array.isArray(tiffins) && Object.values(tiffins).some(tiffin =>
          tiffin && typeof tiffin === 'object' && !Array.isArray(tiffin) && this.categories.every(category => Boolean(tiffin[category])))) return false;
        const ala = dayOrder?.ala;
        if (!ala || typeof ala !== 'object' || Array.isArray(ala)) return false;
        let cents = 0;
        let hasAla = false;
        for (const category of Object.values(ala)) {
          if (!category || typeof category !== 'object' || Array.isArray(category)) continue;
          for (const item of Object.values(category)) {
            if (!item || typeof item !== 'object') continue;
            const quantity = Number(item.quantity) || 0;
            if (!Number.isFinite(quantity) || quantity <= 0) continue;
            const price = Number.parseFloat(item.price || 0);
            if (!Number.isFinite(price) || price < 0) return false;
            hasAla = true;
            cents += Math.round(price * 100) * quantity;
          }
        }
        return hasAla && Math.round(cents) < 2900;
      } catch {
        return false;
      }
    }
    pantryBelowMinimum(day) {
      try {
        const state = JSON.parse(localStorage.getItem(window.HT_MORNING_PREVIEW ? 'htMorningPreviewSelections' : 'selectedTiffins') || 'null');
        const dayOrder = state?.days?.[day];
        const tiffins = dayOrder?.tiffins;
        if (tiffins && typeof tiffins === 'object' && !Array.isArray(tiffins) && Object.values(tiffins).some(tiffin =>
          tiffin && typeof tiffin === 'object' && !Array.isArray(tiffin) && this.categories.every(category => Boolean(tiffin[category])))) return false;
        const hasItems = groups => groups && typeof groups === 'object' && !Array.isArray(groups) && Object.values(groups).some(category =>
          category && typeof category === 'object' && !Array.isArray(category) && Object.values(category).some(item =>
            item && Number.isFinite(Number(item.quantity)) && Number(item.quantity) > 0));
        if (hasItems(dayOrder?.lunch) || hasItems(dayOrder?.ala)) return false;
        const pantry = dayOrder?.pantry;
        if (!pantry || typeof pantry !== 'object' || Array.isArray(pantry)) return false;
        let cents = 0;
        let hasPantry = false;
        for (const category of Object.values(pantry)) {
          if (!category || typeof category !== 'object' || Array.isArray(category)) continue;
          for (const item of Object.values(category)) {
            if (!item || typeof item !== 'object') continue;
            const quantity = Number(item.quantity) || 0;
            if (!Number.isFinite(quantity) || quantity <= 0) continue;
            const price = Number.parseFloat(item.price || 0);
            if (!Number.isFinite(price) || price < 0) return false;
            hasPantry = true;
            cents += Math.round(price * 100) * quantity;
          }
        }
        return hasPantry && Math.round(cents) < 2900;
      } catch {
        return false;
      }
    }
    pantryRecovery(control) {
      if (!control.matches('a[href]')) return false;
      try {
        const url = new URL(control.href, location.href);
        return url.origin === location.origin && ['/pages/order-lunch', '/pages/order-tiffin'].includes(url.pathname.replace(/\/+$/, ''));
      } catch {
        return false;
      }
    }
    categoryLabel(category) {
      const heading = document.querySelector(`#mainProductContainer .main-tiff-type-prod-and-title-wrapper[data-day-category="${category}"] h3`);
      return heading?.textContent.split(':')[0].trim() || this.dataset[`${category}Label`];
    }
    guard(event) {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || this.dialog.open || !(event.target instanceof Element) || this.contains(event.target)) return;
      const main = document.querySelector('.order-tiffin-main-container');
      const mode = ['lunch', 'pantry'].includes(this.dataset.menu) ? this.dataset.menu : document.querySelector('.order-tiffin-type-btn.active')?.dataset.value;
      if (!main || getComputedStyle(main).display === 'none' || !['tiffin', 'ala', 'lunch', 'pantry'].includes(mode)) return;
      const control = this.outgoing(event.target);
      if (!control || (mode === 'ala' && control.matches('.order-tiffin-type-btn')) || (mode === 'pantry' && this.pantryRecovery(control))) return;
      const day = this.calendar().find(button => button.classList.contains('active-day'))?.dataset.day;
      const missing = mode === 'tiffin' ? this.missingTiffins(day) : [];
      const needsReminder = mode === 'lunch' ? this.lunchBelowMinimum(day) : mode === 'ala' ? this.alaBelowMinimum(day) : mode === 'pantry' ? this.pantryBelowMinimum(day) : missing.length > 0;
      if (!needsReminder) return;
      this.dataset.mode = mode;
      const copy = mode === 'ala' ? [this.dataset.alaTitle, this.dataset.alaMessage, this.dataset.alaHint] : this.defaultCopy;
      this.copyNodes.forEach((node, index) => { if (node) node.textContent = copy[index]; });
      const list = this.querySelector('.ht-tiffin-guard__missing');
      list.replaceChildren(...missing.map(tiffin => {
        const group = document.createElement('section');
        group.className = 'ht-tiffin-guard__group';
        const heading = document.createElement('h3');
        heading.textContent = `${this.dataset.tiffinLabel} ${tiffin.number}`;
        const description = document.createElement('p');
        description.append(document.createTextNode(`${this.dataset.missingLabel}: `));
        const names = document.createElement('strong');
        names.textContent = tiffin.missing.map(category => this.categoryLabel(category)).join(', ');
        description.append(names);
        group.append(heading, description);
        return group;
      }));
      this.returnFocus = control;
      try {
        this.dialog.showModal();
        document.body.classList.add('ht-tiffin-guard-open');
      } catch {
        this.returnFocus = null;
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      this.querySelector('.ht-tiffin-guard__close').focus({ preventScroll: true });
    }
  }
  if (!customElements.get('ht-tiffin-completion-guard')) customElements.define('ht-tiffin-completion-guard', HTTiffinCompletionGuard);
})();
  } catch(e) { console.error(e); }
})();

})();
